
import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Building2, Landmark, TreePine, Mountain, Waves, Wheat, Building } from 'lucide-react';

const ExpertiseZones = () => {
  const zones = [
    {
      department: "Aveyron (12)",
      cities: "Rodez, Millau, Villefranche",
      description: "Expertise locale depuis notre siège social à Rodez",
      icon: MapPin,
      link: "/nos-services/achat-metaux/aveyron",
      color: "red"
    },
    {
      department: "Haute-Garonne (31)",
      cities: "Toulouse, Muret, Colomiers",
      description: "Solutions métropole toulousaine et aéronautique",
      icon: Building2,
      link: "/nos-services/achat-metaux/haute-garonne",
      color: "pink"
    },
    {
      department: "Tarn (81)",
      cities: "Albi UNESCO, Castres, Mazamet",
      description: "Respect du patrimoine historique et industriel",
      icon: Landmark,
      link: "/nos-services/achat-metaux/tarn",
      color: "red"
    },
    {
      department: "Lot (46)",
      cities: "Cahors, Figeac, Gourdon",
      description: "Approche écologique et sites protégés",
      icon: TreePine,
      link: "/nos-services/achat-metaux/lot",
      color: "green"
    },
    {
      department: "Cantal (15)",
      cities: "Aurillac, Saint-Flour, Mauriac",
      description: "Solutions adaptées au relief montagnard",
      icon: Mountain,
      link: "/nos-services/achat-metaux/cantal",
      color: "amber"
    },
    {
      department: "Lozère (48)",
      cities: "Mende, Florac, Marvejols",
      description: "Service de proximité en territoire préservé",
      icon: TreePine,
      link: "/nos-services/achat-metaux/lozere",
      color: "emerald"
    },
    {
      department: "Hérault (34)",
      cities: "Montpellier, Béziers, Sète",
      description: "Métropole et littoral méditerranéen",
      icon: Waves,
      link: "/nos-services/achat-metaux/herault",
      color: "cyan"
    },
    {
      department: "Tarn-et-Garonne (82)",
      cities: "Montauban, Moissac, Castelsarrasin",
      description: "Spécialisation agricole et agroalimentaire",
      icon: Wheat,
      link: "/nos-services/achat-metaux/tarn-et-garonne",
      color: "orange"
    },
    {
      department: "Val-d'Oise (95)",
      cities: "Cergy, Argenteuil, Sarcelles",
      description: "Solutions franciliennes et Grand Paris",
      icon: Building,
      link: "/nos-services/achat-metaux/val-doise",
      color: "indigo"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-fabre-gray mb-4">
          Nos zones d'expertise prioritaires
        </h2>
        <p className="text-gray-600 text-center mb-12 max-w-3xl mx-auto">
          Découvrez nos services spécialisés d'achat de métaux adaptés aux spécificités de chaque territoire
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {zones.map((zone, index) => {
            const IconComponent = zone.icon;
            const colorClasses = {
              red: { border: "border-red-200", text: "text-red-600", hover: "hover:text-red-700", hoverBorder: "group-hover:border-red-200" },
              pink: { border: "border-pink-200", text: "text-pink-600", hover: "hover:text-pink-700", hoverBorder: "group-hover:border-pink-200" },
              green: { border: "border-green-200", text: "text-green-600", hover: "hover:text-green-700", hoverBorder: "group-hover:border-green-200" },
              amber: { border: "border-amber-200", text: "text-amber-600", hover: "hover:text-amber-700", hoverBorder: "group-hover:border-amber-200" },
              emerald: { border: "border-emerald-200", text: "text-emerald-600", hover: "hover:text-emerald-700", hoverBorder: "group-hover:border-emerald-200" },
              cyan: { border: "border-cyan-200", text: "text-cyan-500", hover: "hover:text-cyan-600", hoverBorder: "group-hover:border-cyan-200" },
              orange: { border: "border-orange-200", text: "text-orange-500", hover: "hover:text-orange-600", hoverBorder: "group-hover:border-orange-200" },
              indigo: { border: "border-indigo-200", text: "text-indigo-500", hover: "hover:text-indigo-600", hoverBorder: "group-hover:border-indigo-200" }
            };
            const colors = colorClasses[zone.color as keyof typeof colorClasses];

            return (
              <Link key={index} to={zone.link} className="group">
                <div className={`bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-100 ${colors.hoverBorder}`}>
                  <div className="flex items-center mb-4">
                    <IconComponent className={`h-8 w-8 ${colors.text} mr-3`} />
                    <div>
                      <h3 className="font-bold text-gray-800">{zone.department}</h3>
                      <p className="text-sm text-gray-600">{zone.cities}</p>
                    </div>
                  </div>
                  <p className="text-gray-600 text-sm mb-3">
                    {zone.description}
                  </p>
                  <div className={`${colors.text} font-medium ${colors.hover}`}>Voir nos services →</div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseZones;
